const AdminHome 			= () => import(/* webpackChunkName: "admin-home" */ '@/components/AdminHome.vue');
const AppStatistics 		= () => import(/* webpackChunkName: "app-statistics" */ '@/views/AppStatistics.vue');
const UserManagement 		= () => import(/* webpackChunkName: "user-management" */ '@/views/UserManagement.vue');
const SupplierManagement 	= () => import(/* webpackChunkName: "supplier-management" */ '@/views/SupplierManagement.vue');
const SupplierReport		= () => import(/* webpackChunkName: "supplier-report" */ '@/views/SupplierReport.vue');
const AdminOrders 			= () => import(/* webpackChunkName: "admin-orders" */ '@/views/AdminOrders.vue');
const AdminProducts 		= () => import(/* webpackChunkName: "admin-products" */ '@/views/AdminProducts.vue');
const AdminSettings			= () => import(/* webpackChunkName: "admin-settings" */ '@/views/AdminSettings.vue');
const AdminWithdrawals 		= () => import(/* webpackChunkName: "admin-withdrawals" */ '@/views/AdminWithdrawals.vue');
const Billings 				= () => import(/* webpackChunkName: "billings" */ '@/views/Billings.vue');
// const FinanceOverview 		= () => import(/* webpackChunkName: "finance-overview" */ '@/views/FinanceOverview.vue'); // Old Finance View
const FinanceSummary 		= () => import(/* webpackChunkName: "finance-summary" */ '@/views/FinanceSummary.vue'); // New Finance View
const AdminSlider			= () => import(/* webpackChunkName: "admin-slider" */ '@/views/AdminSlider.vue');
const AdminSliderSupplier	= () => import(/* webpackChunkName: "admin-slider-supplier" */ '@/views/AdminSliderSupplier.vue');
const AdminSliderWholesale	= () => import(/* webpackChunkName: "admin-slider-wholesale" */ '@/views/AdminSliderWholesale.vue');
const AdminHomepage			= () => import(/* webpackChunkName: "admin-homepage" */ '@/views/AdminHomepage.vue');
const WalletStash 			= () => import(/* webpackChunkName: "wallet-stash" */ '@/views/WalletStash.vue');
const LoginAdmin			= () => import(/* webpackChunkName: "admin-login" */ '@/views/LoginAdmin.vue');
const AdminBrand			= () => import(/* webpackChunkName: "admin-brand" */ '@/views/AdminBrand.vue');
const AdminDirect			= () => import(/* webpackChunkName: "admin-direct" */ '@/views/AdminDirect.vue');
const AdminProductRequest	= () => import(/* webpackChunkName: "admin-product-request" */ '@/views/AdminProductRequest.vue');
const AdminFraudMonitoring	= () => import(/* webpackChunkName: "admin-fraud-monitoring" */ '@/views/AdminFraudMonitoring.vue');
const AdminWarehouse		= () => import(/* webpackChunkName: "admin-warehouse" */ '@/views/AdminWarehouse.vue');
const AdminAnnouncements	= () => import(/* webpackChunkName: "admin-announcements" */ '@/views/AdminAnnouncements.vue');
const AdminProductContent	= () => import(/* webpackChunkName: "admin-product-content" */ '@/views/AdminProductContent.vue');
const ProductCreator 		= () => import(/* webpackChunkName: "ostock-product-creator" */ '@/views/inventro/ProductCreator.vue');
const AdminActivityLog		= () => import(/* webpackChunkName: "admin-activity-log" */ '@/views/AdminActivityLog.vue');
const AdminSupplierWallet	= () => import(/* webpackChunkName: "admin-supplier-wallet" */ '@/views/AdminSupplierWallet.vue');
const AdminWallet			= () => import(/* webpackChunkName: "admin-wallet" */ '@/views/AdminWallet.vue');
const AdminProductDetail 	= () => import(/* webpackChunkName: "admin-product-detail" */ '@/views/HomepageProductDetail.vue');
const AdminProductWholesaleDetail 	= () => import(/* webpackChunkName: "admin-product-wholesale-detail" */ '@/views/PrivateOrderDetail.vue');
const AdminHandlingFees 	= () => import(/* webpackChunkName: "admin-handling-fees" */ '@/views/AdminHandlingFees.vue');
const AdminExportPage 	= () => import(/* webpackChunkName: "admin-export-page" */ '@/views/AdminExportPage.vue');
const AdminSales 			= () => import(/* webpackChunkName: "admin-sales" */ '@/views/AdminSales.vue');
const AdminSalesDetail		= () => import(/* webpackChunkName: "admin-sales-detail" */ '@/views/AdminSalesDetail.vue');
const AdminSalesMonitoring	= () => import(/* webpackChunkName: "admin-sales-monitoring" */ '@/views/AdminSalesMonitoring.vue');
const AdminSalesMonitoringDetail = () => import(/* webpackChunkName: "admin-sales-monitoring-detail" */ '@/views/AdminSalesMonitoringDetail.vue');
const AdminTicket			= () => import(/* webpackChunkName: "admin-ticket" */ '@/views/AdminTicket.vue');
const AdminAskStock			= () => import(/* webpackChunkName: "admin-ask-stock" */ '@/views/AdminAskStock.vue');
const ProductRequest		= () => import(/* webpackChunkName: "product-request" */ '@/views/ProductRequest.vue');
const AdminLeadsOrder		= () => import(/* webpackChunkName: "admin-leads-order" */ '@/views/AdminLeadsOrder.vue');
const AdminNotificationCenter	= () => import(/* webpackChunkName: "admin-notification-center" */ '@/views/AdminNotificationCenter.vue');
const AdminOrderStatistic	= () => import(/* webpackChunkName: "admin-order-statistic" */ '@/views/AdminOrderStatistic.vue');
const AdminProductHistory	= () => import(/* webpackChunkName: "admin-product-history" */ '@/views/Inventory.vue');
const AdminChangeSource	= () => import(/* webpackChunkName: "admin-change-source" */ '@/views/AdminChangeSource.vue');
const AdminCreditDetail	= () => import(/* webpackChunkName: "admin-credit-detail" */ '@/views/AdminCreditDetail.vue');
const AdminMonitoringStock = () => import(/* webpackChunkName: "admin-monitoring-stock" */ '@/views/AdminMonitoringStock.vue');
const AdminCreditCancel	= () => import(/* webpackChunkName: "admin-credit-cancel" */ '@/views/AdminCreditCancel.vue');
const AdminPopupInformation = () => import(/* webpackChunkName: "admin-popup-information" */ '@/views/AdminPopupInformation.vue');
const AdminPrivateOrder = () => import(/* webpackChunkName: "admin-private-order" */ '@/views/AdminPrivateOrder.vue');
const AdminOtp = () => import(/* webpackChunkName: "admin-otp" */ '@/views/AdminOtp.vue');
const AdminCommission		= () => import(/* webpackChunkName: "admin-commission" */ '@/views/AdminCommission.vue');
const AdminRevenueStream = () => import(/* webpackChunkName: "admin-revenue-stream" */ '@/views/AdminRevenueStream.vue');
const AdminSellerTopupMonitoring = () => import(/* webpackChunkName: "admin-seller-topup-monitoring" */ '@/views/AdminSellerTopupMonitoring.vue');
const AdminWalletDraft = () => import(/* webpackChunkName: "admin-wallet-draft" */ '@/views/AdminWalletDraft.vue');


const APP_NAME = process.env.VUE_APP_NAME;

const adminRoutes = [
	{
		path: '/admin',
		name: 'admin',
		component: AdminHome,
		meta: {
			layout: 'Admin',
			title: `Admin - ${APP_NAME}`,
			gtm: 'Admin',
			slug: 'admin',
			capabilities: 'admin_home_view',
		},
	},
	{
		path: '/admin/user/:role',
		name: 'adminUser',
		component: UserManagement,
		meta: {
			layout: 'Admin',
			title: `User Management - ${APP_NAME}`,
			gtm: 'User Management',
			slug: 'user',
			capabilities: 'admin_users_view',
		},
	},
	{
		path: '/admin/stats',
		name: 'adminStats',
		component: AppStatistics,
		meta: {
			layout: 'Admin',
			title: `App Statistics - ${APP_NAME}`,
			gtm: 'App Statistics',
			slug: 'statistics',
			capabilities: 'admin_statistic_view',
		},
	},
	{
		path: '/admin/supplier',
		name: 'adminSupplier',
		component: SupplierManagement,
		meta: {
			layout: 'Admin',
			title: `Supplier Management - ${APP_NAME}`,
			gtm: 'Supplier Management',
			slug: 'user',
			capabilities: 'admin_supplier_view',
		},
	},
	{
		path: '/admin/supplier-report',
		name: 'adminSupplierReport',
		component: SupplierReport,
		meta: {
			layout: 'Admin',
			title: `Supplier Report - ${APP_NAME}`,
			gtm: 'Supplier Report',
			slug: 'supplier',
			capabilities: 'admin_supplier_view',
		},
	},
	{
		path: '/admin/orders/:type?',
		name: 'adminOrders',
		component: AdminOrders,
		meta: {
			layout: 'Admin',
			title: `Order Monitoring - ${APP_NAME}`,
			gtm: 'Order Monitoring',
			slug: 'orders',
			capabilities: 'admin_monitoring_orders_view',
		},
	},
	{
		path: '/admin/wholesale-order',
		name: 'adminPrivateOrder',
		component: AdminPrivateOrder,
		meta: {
			layout: 'Admin',
			title: `Wholesale Orders - ${APP_NAME}`,
			gtm: 'Private Order',
			slug: 'private-order',
			capabilities: 'admin_private_order_view',
		},
	},
	{
		path: '/admin/products',
		name: 'adminProducts',
		component: AdminProducts,
		meta: {
			layout: 'Admin',
			title: `Products - ${APP_NAME}`,
			gtm: 'Products',
			slug: 'products',
			capabilities: 'admin_product_view',
		},
	},
	{
		path: '/admin/products/preview/:slug',
		name: 'adminProductDetail',
		component: AdminProductDetail,
		meta: {
			layout: 'Admin',
			title: `Products - ${APP_NAME}`,
			gtm: 'Products',
			slug: 'products',
			capabilities: 'admin_product_view',
		},
	},
	{
		path: '/admin/products/wholesale/preview/:slug',
		name: 'adminProductWholesaleDetail',
		component: AdminProductWholesaleDetail,
		meta: {
			layout: 'Admin',
			title: `Products - ${APP_NAME}`,
			gtm: 'Products',
			slug: 'products',
			capabilities: 'admin_product_view',
		},
	},
	{
		path: '/admin/products/new',
		name: 'adminProductCreator',
		component: ProductCreator,
		meta: {
			layout: 'Admin',
			title: `Product Creator - ${APP_NAME}`,
			gtm: 'Admin ProductCreator',
			slug: 'products',
			capabilities: 'admin_product_add',
		},
	},
	{
		path: '/admin/activity-log',
		name: 'adminActivityLog',
		component: AdminActivityLog,
		meta: {
			layout: 'Admin',
			title: `Admin Activity Log - ${APP_NAME}`,
			gtm: 'Admin Activity Log',
			slug: 'activity-log',
			capabilities: 'admin_activity_log_view',
		},
	},
	{
		path: '/admin/ticket',
		name: 'adminTicket',
		component: AdminTicket,
		meta: {
			layout: 'Admin',
			title: `Admin Monitoring Ticket - ${APP_NAME}`,
			gtm: 'Admin Monitoring Ticket',
			slug: 'ticket',
			capabilities: 'admin_ticket_view',
		},
	},
	{
		path: '/admin/ask-stocks',
		name: 'adminAskStock',
		component: AdminAskStock,
		meta: {
			layout: 'Admin',
			title: `Admin Ask Stock - ${APP_NAME}`,
			gtm: 'Admin Ask Stock',
			slug: 'ask-stocks',
			capabilities: 'admin_ask_stock_view',
		},
	},
	{
		path: '/admin/products/:id/edit',
		name: 'adminProductEdit',
		component: ProductCreator,
		meta: {
			layout: 'Admin',
			title: `Product Creator Edit - ${APP_NAME}`,
			gtm: 'Admin ProductCreator - Edit',
			slug: 'products',
			capabilities: 'admin_product_edit',
		},
		props: route => ({
			id: route.params.id,
			entity: 'product',
			action: 'edit',
		}),
	},
	{
		path: '/admin/request-product/new',
		name: 'admin-product-request',
		component: ProductRequest,
		meta: {
			layout: 'Admin',
			title: `Admin Create Request Product - ${APP_NAME}`,
			gtm: 'Admin Create Request Product',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/settings',
		name: 'adminSettings',
		component: AdminSettings,
		meta: {
			layout: 'Admin',
			title: `Settings - ${APP_NAME}`,
			gtm: 'Settings',
			slug: 'settings',
			capabilities: 'admin_setting_view',
		},
	},
	{
		path: '/admin/withdrawals',
		name: 'adminWithdrawals',
		component: AdminWithdrawals,
		meta: {
			layout: 'Admin',
			title: `Withdrawals - ${APP_NAME}`,
			gtm: 'Withdrawals',
			slug: 'withdrawals',
			capabilities: 'admin_withdrawal_view',
		},
	},
	{
		path: '/admin/billings',
		name: 'billings',
		component: Billings,
		meta: {
			layout: 'Admin',
			title: `Bilings - ${APP_NAME}`,
			gtm: 'Bilings',
			slug: 'billings',
			capabilities: 'admin_billing_view',
		},
		props: () => ({
			mode: 'admin',
		}),
	},
	{
		path: '/admin/finance',
		name: 'finance',
		component: FinanceSummary,
		meta: {
			layout: 'Admin',
			title: `Finance - ${APP_NAME}`,
			gtm: 'Finance',
			slug: 'finance',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/revenue-stream',
		name: 'revenue-stream',
		component: AdminCommission,
		meta: {
			layout: 'Admin',
			title: `Revenue Stream - ${APP_NAME}`,
			gtm: 'Revenue Stream',
			slug: 'revenue-stream',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/revenue-new',
		name: 'revenue-new',
		component: AdminRevenueStream,
		meta: {
			layout: 'Admin',
			title: `Revenue New - ${APP_NAME}`,
			gtm: 'Revenue New',
			slug: 'revenue-new',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/supplier-wallet',
		name: 'supplier-wallet',
		component: AdminSupplierWallet,
		meta: {
			layout: 'Admin',
			title: `Supplier Wallet - ${APP_NAME}`,
			gtm: 'Supplier-Wallet',
			slug: 'supplier-wallet',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/supplier-wallet/credit-detail',
		name: 'credit-detail',
		component: AdminCreditDetail,
		meta: {
			layout: 'Admin',
			title: `Credit Detail - ${APP_NAME}`,
			gtm: 'Credit Detail',
			slug: 'credit-detail',
			capabilities: 'admin_credit_detail_view',
		},
	},

	{
		path: '/admin/dropshipper-wallet',
		name: 'dropshipper-wallet',
		component: AdminWallet,
		props: { ownerType: 'dropshipper' },
		meta: {
			layout: 'Admin',
			title: `Dropshipper Wallet - ${APP_NAME}`,
			gtm: 'Dropshipper-Wallet',
			slug: 'dropshipper-wallet',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/dropshipper-wallet/credit-detail',
		name: 'dropshipper-credit-detail',
		component: AdminCreditDetail,
		meta: {
			layout: 'Admin',
			title: `Credit Detail - ${APP_NAME}`,
			gtm: 'Credit Detail',
			slug: 'dropshipper-credit-detail',
			capabilities: 'admin_credit_detail_view',
		},
	},
	{
		path: '/admin/seller-topup-monitoring',
		name: 'admin-seller-topup-monitoring',
		component: AdminSellerTopupMonitoring,
		meta: {
			layout: 'Admin',
			title: `Seller Topup Monitoring - ${APP_NAME}`,
			gtm: 'Seller Topup Monitoring',
			slug: 'seller-topup-monitoring',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/wallet-draft',
		name: 'admin-wallet-draft',
		component: AdminWalletDraft,
		meta: {
			layout: 'Admin',
			title: `Wallet Draft - ${APP_NAME}`,
			gtm: 'Wallet Draft',
			slug: 'wallet-draft',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/credit/stash/:type?',
		name: 'admin-credit-stash',
		component: WalletStash,
		meta: {
			layout: 'Admin',
			title: `Admin Credit Stash - ${APP_NAME}`,
			gtm: 'Admin Credit Stash',
			slug: 'handling-fee',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/slider',
		name: 'adminSlider',
		component: AdminSlider,
		meta: {
			layout: 'Admin',
			title: `Slider - ${APP_NAME}`,
			gtm: 'Slider',
			slug: 'slider',
			capabilities: 'admin_slide_banner_view',
		},
	},
	{
		path: '/admin/supplier-slider',
		name: 'adminSliderSupplier',
		component: AdminSliderSupplier,
		meta: {
			layout: 'Admin',
			title: `Slider - ${APP_NAME}`,
			gtm: 'Slider',
			slug: 'supplier-slider',
			capabilities: 'admin_slide_banner_view',
		},
	},
	{
		path: '/admin/wholesale-slider',
		name: 'adminWholesaleSupplier',
		component: AdminSliderWholesale,
		meta: {
			layout: 'Admin',
			title: `Slider - ${APP_NAME}`,
			gtm: 'Slider',
			slug: 'wholesale-slider',
			capabilities: 'admin_slide_banner_view',
		},
	},
	{
		path: '/admin/homepage',
		name: 'adminHomepage',
		component: AdminHomepage,
		meta: {
			layout: 'Admin',
			title: `Homepage - ${APP_NAME}`,
			gtm: 'Homepage',
			slug: 'homepage',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/login',
		name: 'AdminLogin',
		component: LoginAdmin,
		meta: {
			layout: 'Main',
			title: `Login - ${APP_NAME}`,
			gtm: 'Admin Login',
			slug: 'admin_login',
		},
	},
	{
		path: '/admin/brand',
		name: 'AdminBrand',
		component: AdminBrand,
		meta: {
			layout: 'Admin',
			title: `Brand - ${APP_NAME}`,
			gtm: 'Admin Brand',
			slug: 'admin_brand',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/direct',
		name: 'AdminDirect',
		component: AdminDirect,
		meta: {
			layout: 'Admin',
			title: `Direct - ${APP_NAME}`,
			gtm: 'Admin Direct',
			slug: 'admin_direct',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/request-product',
		name: 'AdminProductRequest',
		component: AdminProductRequest,
		meta: {
			layout: 'Admin',
			title: `Request Product - ${APP_NAME}`,
			gtm: 'Admin Request Product',
			slug: 'admin_product_request',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/fraud-monitoring',
		name: 'AdminFraudMonitoring',
		component: AdminFraudMonitoring,
		meta: {
			layout: 'Admin',
			title: `Fraud Monitoring - ${APP_NAME}`,
			gtm: 'Admin Fraud Monitoring',
			slug: 'fraud-monitoring',
			capabilities: 'admin_fraud_monitoring_view',
		},
	},
	{
		path: '/admin/warehouse',
		name: 'AdminWarehouse',
		component: AdminWarehouse,
		meta: {
			layout: 'Admin',
			title: `Warehouse - ${APP_NAME}`,
			gtm: 'Admin Warehouse',
			slug: 'admin_warehouse',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/announcements',
		name: 'AdminAnnouncements',
		component: AdminAnnouncements,
		meta: {
			layout: 'Admin',
			title: `Announcements - ${APP_NAME}`,
			gtm: 'Admin Announcements',
			slug: 'admin_announcements',
			capabilities: 'admin_homepage_view',
		},
	},
	{
		path: '/admin/marketing-kit',
		name: 'AdminProductContent',
		component: AdminProductContent,
		meta: {
			layout: 'Admin',
			title: `Marketing Kit - ${APP_NAME}`,
			gtm: 'Admin Marketing Kit',
			slug: 'admin_product_content',
			capabilities: 'admin_product_view',
		},
	},
	{
		path: '/admin/handling-fee',
		name: 'handling-fees',
		component: AdminHandlingFees,
		meta: {
			layout: 'Admin',
			title: `Handling Fee - ${APP_NAME}`,
			gtm: 'Handling-Fee',
			slug: 'handling-fee',
			capabilities: 'admin_finance_view',
		},
	},
	{
		path: '/admin/export-page',
		name: 'export-page',
		component: AdminExportPage,
		meta: {
			layout: 'Admin',
			title: `Export Page - ${APP_NAME}`,
			gtm: 'Export-Page',
			slug: 'export-page',
			capabilities: 'admin_export_page_view',
		},
	},
	{
		path: '/admin/sales',
		name: 'sales',
		component: AdminSales,
		meta: {
			layout: 'Admin',
			title: `Sales - ${APP_NAME}`,
			gtm: 'sales',
			slug: 'sales',
			capabilities: 'admin_sales_view',
		},
	},
	{
		path: '/admin/sales/:sales_id',
		name: 'sales-detail',
		component: AdminSalesDetail,
		meta: {
			layout: 'Admin',
			title: `Sales Detail - ${APP_NAME}`,
			gtm: 'sales-detail',
			slug: 'sales',
			capabilities: 'admin_sales_view',
		},
	},
	{
		path: '/admin/monitoring-sales',
		name: 'monitoring-sales',
		component: AdminSalesMonitoring,
		meta: {
			layout: 'Admin',
			title: `Monitoring Sales - ${APP_NAME}`,
			gtm: 'monitoring-sales',
			slug: 'monitoring-sales',
			capabilities: 'admin_monitoring_sales_view',
		},
	},
	{
		path: '/admin/monitoring-sales/:sales_id',
		name: 'monitoring-sales-detail',
		component: AdminSalesMonitoringDetail,
		meta: {
			layout: 'Admin',
			title: `Monitoring Sales Detail - ${APP_NAME}`,
			gtm: 'monitoring-sales-detail',
			slug: 'monitoring-sales',
			capabilities: 'admin_monitoring_sales_view',
		},
	},
	{
		path: '/admin/leads-order',
		name: 'leads-order',
		component: AdminLeadsOrder,
		meta: {
			layout: 'Admin',
			title: `Leads Order - ${APP_NAME}`,
			gtm: 'leads-order',
			slug: 'leads-order',
			capabilities: 'admin_leads_order_view',
		},
	},
	{
		path: '/admin/notification-center',
		name: 'admin-notification-center',
		component: AdminNotificationCenter,
		meta: {
			layout: 'Admin',
			title: `Notification Center - ${APP_NAME}`,
			gtm: 'notification-center',
			slug: 'notification-center',
			capabilities: 'notification_center_view',
		},
	},
	{
		path: '/admin/product-history',
		name: 'product-history',
		component: AdminProductHistory,
		meta: {
			layout: 'Admin',
			title: `Product History - ${APP_NAME}`,
			gtm: 'product-history',
			slug: 'product-history',
			capabilities: 'admin_product_history_view',
		},
	},
	{
		path: '/admin/change-source',
		name: 'change-source',
		component: AdminChangeSource,
		meta: {
			layout: 'Admin',
			title: `Change Source - ${APP_NAME}`,
			gtm: 'change-source',
			slug: 'change-source',
			capabilities: 'admin_change_source_view',
		},
	},
	{
		path: '/admin/order-statistic',
		name: 'order-statistic',
		component: AdminOrderStatistic,
		meta: {
			layout: 'Admin',
			title: `Order Statistic - ${APP_NAME}`,
			gtm: 'order-statistic',
			slug: 'order-statistic',
			capabilities: 'admin_order_statistic_view',
		},
	},
	{
		path: '/admin/monitoring-stock',
		name: 'monitoring-stock',
		component: AdminMonitoringStock,
		meta: {
			layout: 'Admin',
			title: `Monitoring Stock - ${APP_NAME}`,
			gtm: 'Monitoring Stock',
			slug: 'monitoring-stock',
			capabilities: 'admin_monitoring_stock_view',
		},
	},
	{
		path: '/admin/credit-cancel',
		name: 'credit-cancel',
		component: AdminCreditCancel,
		meta: {
			layout: 'Admin',
			title: `Credit Cancel - ${APP_NAME}`,
			gtm: 'credit-cancel',
			slug: 'credit-cancel',
			capabilities: 'admin_credit_cancel',
		},
	},
	{
		path: '/admin/popup-information',
		name: 'popup-information',
		component: AdminPopupInformation,
		meta: {
			layout: 'Admin',
			title: `Admin Popup Information - ${APP_NAME}`,
			gtm: 'popup-information',
			slug: 'popup-information',
			capabilities: 'admin_popup_information_view',
		},
	},
	{
		path: '/admin/otp',
		name: 'otp',
		component: AdminOtp,
		meta: {
			layout: 'Admin',
			title: `Admin OTP - ${APP_NAME}`,
			gtm: 'admin-otp',
			slug: 'admin-otp',
			capabilities: 'admin_otp_page_view',
		},
	},
];

export default adminRoutes;
